"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  transition: background 0.1s linear, color 0.1s linear;\n  background: ", ";\n  padding: ", " ", ";\n  cursor: pointer;\n  position: relative;\n  > :first-child {\n    margin-right: ", ";\n    font-size: ", ";\n    transition: color 0.1s linear;\n    color: ", ";\n  }\n  &:first-child {\n    padding-left: ", ";\n  }\n  &:not(:last-child)::after {\n    content: ' ';\n    display: block;\n    width: 0;\n    height: 0;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: -", ";\n    transition: border-left-color 0.1s linear;\n    border-top: calc(", " / 2) solid transparent;\n    border-bottom: calc(", " / 2) solid transparent;\n    border-left: ", " solid\n      ", ";\n    z-index: 501;\n  }\n  &:not(:last-child)::before {\n    content: ' ';\n    display: block;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: calc(-", " - 2px);\n    transition: border-left-color 0.1s linear;\n    border-top: calc(", " / 2) solid transparent;\n    border-bottom: calc(", " / 2) solid transparent;\n    border-left: calc(", " + 2px) solid\n      ", ";\n    z-index: 500;\n  }\n  &:hover {\n    background: ", ";\n    &:not(:last-child)::after {\n      border-left-color: ", ";\n    }\n    &:not(:last-child)::before {\n      border-left-color: ", ";\n    }\n  }\n  &.active {\n    background: ", ";\n    color: ", ";\n    &:not(:last-child)::after {\n      border-left-color: ", ";\n    }\n    &:not(:last-child)::before {\n      border-left-color: ", ";\n    }\n    > :first-child {\n      color: ", ";\n    }\n  }\n  &.disabled {\n    cursor: default;\n    background: ", ";\n    * {\n      color: ", " !important;\n    }\n    &::after {\n      border-left-color: ", ";\n    }\n    &:not(:last-child)::before {\n      border-left-color: ", ";\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: stretch;\n  flex-wrap: nowrap;\n  height: ", ";\n  border-radius: ", ";\n  overflow: hidden;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pipeline = void 0;

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var Typography_1 = require("./Typography");

var styledTypes_1 = require("./styledTypes");

function Pipeline(_ref) {
  var onChange = _ref.onChange,
      activeKey = _ref.activeKey,
      steps = _ref.steps,
      disabled = _ref.disabled;
  return react_1.default.createElement(Container, null, steps.map(function (_ref2) {
    var name = _ref2.name,
        subtitle = _ref2.subtitle,
        tooltip = _ref2.tooltip,
        icon = _ref2.icon,
        key = _ref2.key,
        itemDisabled = _ref2.disabled,
        _ref2$activeColor = _ref2.activeColor,
        activeColor = _ref2$activeColor === void 0 ? '@primary-color' : _ref2$activeColor;
    var contents = react_1.default.createElement(Step, {
      key: key,
      activeColor: activeColor,
      className: disabled || itemDisabled ? 'disabled' : activeKey === key ? 'active' : '',
      onClick: activeKey === key || disabled || itemDisabled ? undefined : function () {
        onChange(key);
      }
    }, react_1.default.createElement("div", {
      children: icon
    }), react_1.default.createElement("div", null, react_1.default.createElement(Typography_1.BodyLarge, {
      children: name,
      style: {
        lineHeight: 1.2
      },
      weight: Typography_1.FontWeight.SemiBold
    }), react_1.default.createElement(Typography_1.BodySmall, {
      children: subtitle,
      style: {
        lineHeight: 1
      }
    })));

    if (tooltip) {
      return react_1.default.createElement(antd_1.Tooltip, {
        title: tooltip
      }, contents);
    } else return contents;
  }));
}

exports.Pipeline = Pipeline;
var HEIGHT = '@size-xxl';
var Container = styledTypes_1.styled.div(_templateObject(), function (props) {
  return props.theme[HEIGHT];
}, function (props) {
  return props.theme['@border-radius-base'];
});
var Step = styledTypes_1.styled.div(_templateObject2(), function (props) {
  return props.theme['@background-color-base'];
}, function (props) {
  return props.theme['@size-s'];
}, function (props) {
  return props.theme['@size-l'];
}, function (props) {
  return props.theme['@size-s'];
}, function (props) {
  return props.theme['@size-m'];
}, function (props) {
  return props.theme['@text-color-secondary'];
}, function (props) {
  return props.theme['@size-s'];
}, function (props) {
  return props.theme['@size-xs'];
}, function (props) {
  return props.theme[HEIGHT];
}, function (props) {
  return props.theme[HEIGHT];
}, function (props) {
  return props.theme['@size-xs'];
}, function (props) {
  return props.theme['@background-color-base'];
}, function (props) {
  return props.theme['@size-xs'];
}, function (props) {
  return props.theme[HEIGHT];
}, function (props) {
  return props.theme[HEIGHT];
}, function (props) {
  return props.theme['@size-xs'];
}, function (props) {
  return props.theme['@border-color-base'];
}, function (props) {
  return props.theme['@gray-3'];
}, function (props) {
  return props.theme['@gray-3'];
}, function (props) {
  return props.theme['@gray-3'];
}, function (props) {
  return props.theme[props.activeColor];
}, function (props) {
  return props.theme['@gray-0'];
}, function (props) {
  return props.theme[props.activeColor];
}, function (props) {
  return props.theme[props.activeColor];
}, function (props) {
  return props.theme['@gray-0'];
}, function (props) {
  return props.theme['@background-color-light'];
}, function (props) {
  return props.theme['@gray-3'];
}, function (props) {
  return props.theme['@background-color-light'];
}, function (props) {
  return props.theme['@background-color-light'];
});